import React, { useEffect } from 'react';

import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import EditPage from 'components/shared/CRUD/components/InnerPage/EditPage';
import { showSuccessSnackbar } from 'components/shared/Snackbar';
import useForceRefresh from 'components/shared/hooks/useForceRefresh';
import { showSnackbar } from 'components/shared/index';

import { EditPageProps } from './types';

export interface WithEditPageLayoutProps extends EditPageProps {
  methods: UseFormReturn<any>;
  onSubmit: (props: any) => Promise<any>;
}

const WithEditPageLayout = <CProps extends WithEditPageLayoutProps>(
  Component: React.FC<CProps & EditPageProps>
) => {
  function WithEditPageLayoutWrapper(props) {
    const { timestamp: isEditable, refresh: setIsEditable } = useForceRefresh();
    const { t } = useTranslation('common');

    useEffect(() => {
      props.methods.reset(props.currentViewData);
    }, [props.currentViewData]);

    const handleSubmit = async (data) => {
      try {
        await props.onSubmit(data).then(() => {
          setIsEditable();
          props.setIsDirty(false);
          showSuccessSnackbar();
        });
      } catch {
        showSnackbar({
          severity: 'error',
          message: t('somethingWentWrong')
        });
      }
    };

    return (
      <EditPage
        onCancel={() => {
          props?.onCancel ? props.onCancel() : props.methods.reset();
        }}
        methods={props.methods}
        onSubmit={props.methods.handleSubmit(handleSubmit)}
        toggleInnerLayout={props.toggleInnerLayout}
        currentView={props.currentViewData}
        setCurrentView={props.setCurrentViewData}
        views={props.rows}
        navigatorLabelGetter={['name']}
        navigatorValueGetter={'groupId'}
        withTabs={true}
        onSetEditMode={props.setIsNavigationDisabled}
        isEditable={isEditable}
        onIsDirty={props.setIsDirty}
      >
        <Component {...props} rowData={props.currentViewData}></Component>
      </EditPage>
    );
  }
  return WithEditPageLayoutWrapper;
};

export default WithEditPageLayout;
